export const LayoutActionTypes = {
    CHANGE_LAYOUT_COLOR: '@@layout/CHANGE_LAYOUT_COLOR',
    CHANGE_SIDEBAR_THEME: '@@layout/CHANGE_SIDEBAR_THEME',
    CHANGE_SIDEBAR_TYPE: '@@layout/CHANGE_SIDEBAR_TYPE',
};
